import React from 'react';
import { Spin } from 'antd';
import './style.less';

const PageLoading = () => (
  <div className="page-loading-container">
    <Spin size="large" tip="加载中..." />
  </div>
);

export default PageLoading;

